import React from 'react';
import Content from '@/components/foundations/content';
import LogoSvg from '@/svgs/common/logo';
import Button from '@/components/objects/button';
import Attention from '@/components/projects/attention';
import { trackInquiryClick } from '@/components/foundations/openaiTracking';
import * as styles from './conversion.module.scss';
import * as Buttonstyles from '@/components/objects/button/button.module.scss';

const ConversionContent: React.FC<{ modal: Function }> = ({ modal }) => {
  return (
    <>
      <h2>
        <small>プロジェクトを成功に導くスペシャリスト</small>
        <strong>
          <LogoSvg />
          <span>
            に<br />
            ぜひご相談ください
          </span>
        </strong>
      </h2>
      <Attention>
        <a href="https://pivot.jp/contact" onClick={trackInquiryClick}>
          <Button
            className={`${(styles.oButton, Buttonstyles.conversion)}`}
          >
            相談してみる
          </Button>
        </a>
      </Attention>
    </>
  );
};

const Conversion: React.FC<{ modal: Function }> = ({ modal }) => {
  return (
    <Content className={{ wrapper: styles.oConversion, inner: styles.lContent__inner }}>
      <ConversionContent modal={modal} />
    </Content>
  );
};

export default Conversion;
